import { FlatList, View } from 'react-native';
import React, { useEffect, useRef, useState } from 'react';
import { PickerItem } from 'design-system/picker/PickerItem';
import PopUpMenuModal, { defaultPopUpWidth, } from 'design-system/PopUpMenuModal.web';
import { rem } from 'design-system/values';
import Modal from 'utils/packages/Modal';
import { isWeb } from '../../constants';
const PickerModal = ({ overlay, onSelected, pickerOptions, selectedIconFill, hideAfterCallback, selectedValue: initialSelectedValue, }) => {
    const [selectedValue, setSelectedValue] = useState(initialSelectedValue);
    const timeoutRef = useRef(undefined);
    useEffect(() => () => {
        clearTimeout(timeoutRef.current);
    }, []);
    return (<View>
      <FlatList data={pickerOptions} renderItem={(info) => (<PickerItem selectedIconFill={selectedIconFill} label={info.item.label} value={info.item.value} icon={info.item.icon} selected={info.item.itemKey
                ? info.item.itemKey === selectedValue?.itemKey
                : info.item.value === selectedValue?.value} disabled={info.item.disabled} onPress={() => {
                setSelectedValue(info.item);
                if (hideAfterCallback) {
                    onSelected?.(info.item, info.index);
                    timeoutRef.current = setTimeout(() => {
                        PickerModal.hide();
                    }, 50);
                }
                else {
                    PickerModal.hide(() => {
                        onSelected?.(info.item, info.index);
                    });
                }
            }}/>)}/>
      {overlay}
    </View>);
};
const PickerModalMemo = React.memo(PickerModal);
/**
 * @param props
 * @param options
 * @param viewRef Only relevant when the platform is the Web.
 *   Open a popup modal next to it if `viewRef` is defined.
 *   Otherwise, open a normal modal at the center of the screen.
 */
PickerModal.show = (props, options, viewRef) => {
    if (isWeb && viewRef) {
        viewRef.current?.measure((_, __, ___, ____, fx, fy) => {
            PopUpMenuModal.show(<PickerModalMemo {...props} hideAfterCallback={props?.hideAfterCallback}/>, {
                fx: fx - defaultPopUpWidth + rem(56),
                fy: fy + rem(56),
                containerStyle: options?.containerStyle,
            });
        });
    }
    else {
        Modal.show(<PickerModalMemo {...props} hideAfterCallback={props?.hideAfterCallback}/>, { containerStyle: styles.container, ...options });
    }
};
PickerModal.hide = (onDidHideCallback) => {
    // Calling hide on either modal that is not open should have no effect
    PopUpMenuModal.hide(onDidHideCallback);
    Modal.hide(onDidHideCallback);
};
const styles = {
    container: {
        paddingHorizontal: rem(isWeb ? 8 : 0),
    },
};
export { PickerModal };
